import { styled } from '@mui/material/styles';
import TableRow, { TableRowProps } from '@mui/material/TableRow';

const StyledTableRow: React.FC<TableRowProps> = styled(TableRow)<TableRowProps>(
  ({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
      cursor: 'pointer',
    },
  })
);

export default StyledTableRow;
